import { useEffect, useState } from 'react';
import { loadPhotoSrc } from '../lib/photoFiles';

export function usePhotoSrc(photoId: string): { src: string | null; loading: boolean } {
  const [src, setSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    if (!photoId) {
      setSrc(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    loadPhotoSrc(photoId)
      .then((url) => {
        if (!alive) return;
        setSrc(url);
      })
      .catch(() => {
        if (alive) setSrc(null);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [photoId]);

  return { src, loading };
}
